import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationStep } from 'embed/constants'
import { StepbystepCreditApplicationWrapper } from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchReturnToOriginalStep: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStep: ApplicationStep | undefined
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepName: React.FC<Props> = (props) => (
  <StepbystepCreditApplicationWrapper {...props}>
    <StepTitle>What’s your name?</StepTitle>
    <ApplicationField product={Product.CreditCard} field={Fields.FirstName} forceFocus={true} onEnter={props.onEnter} />
    <ApplicationField product={Product.CreditCard} field={Fields.LastName} onEnter={props.onEnter} />
  </StepbystepCreditApplicationWrapper>
)
